// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".module-image{width:100%;height:100%}.module-image img{height:auto}\n", "",{"version":3,"sources":["webpack://./moduleImage.scss"],"names":[],"mappings":"AAAA,cACE,UAAW,CACX,WAAY,CAFd,kBAII,WAAY","sourcesContent":[".module-image{\n  width: 100%;\n  height: 100%;\n  img{\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
